import { BaseService } from '../base';

export type Cnae = {
  id: string;
  code: number;
  description: string;
  riskCode: number;
};

export type CnaeMeta = {
  pageNumber: number;
  pageSize: number;
  total: number;
  totalPages: number;
};

export type CnaesResponse = {
  data: Cnae[];
  meta: CnaeMeta;
};

export type GetCnaesParams = {
  filter?: string;
  pageNumber?: number;
  pageSize?: number;
};

export class CnaesService extends BaseService {
  async getCnaes(
    params: GetCnaesParams = {}
  ): Promise<{
    success: boolean;
    data?: CnaesResponse;
    error?: string;
  }> {
    try {
      const { filter, pageNumber = 1, pageSize = 1000 } = params;

      const queryParams = new URLSearchParams({
        pageNumber: String(pageNumber),
        pageSize: String(pageSize),
      });

      const trimmedFilter = filter?.trim();
      if (trimmedFilter) {
        queryParams.set('filter', trimmedFilter);
      }

      const path = `/portal/v1/products/cnaes?${queryParams.toString()}`;
      const response = await this.get(path, {}, import.meta.env.VITE_API_URL);

      return await this.handleJsonResponse<CnaesResponse>(response);
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error
            ? error.message
            : 'Erro ao carregar CNAEs',
      };
    }
  }
}

export const cnaesService = new CnaesService();
